export const ExternalOrderDeliveryPublish = () => {
    return (
        <>
            <div className="fiter_wrap">
                <div className="fiter_top">
                    <h3 className="filter_heading">납품 검색</h3>
                    <div className="filter_toolbar"></div>
                </div>
                <div className="row">
                    <div className="col-6">
                        <div className="frm_row search justify-content-start">
                            <label for="" className="form-label frm_label">상태</label>
                            <select className="form-select w-150px">
                                <option>전체</option>
                            </select>
                        </div>
                    </div>
                    <div className="col-6">
                        <div className="frm_row">
                            <label for="" className="form-label frm_label">발주일자</label>
                            <div className="frm_field input_date">
                                <input type="date" className="form-control" />
                                <span className="txt_range">~</span>
                                <input type="date" className="form-control me-0" />
                                <button className="btn btn-info btn_search">
                                    <img src={process.env.PUBLIC_URL + "/assets/images/icon_search.png"} alt="" />조회
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div className="content_wrap">
                <div className="table_top">
                    <h6 className="table_stats">납품 목록(<span>13</span>건)</h6>
                    <div className="table_toolbar">
                        <button className="btn btn-dark w-150px px-0"><img src={process.env.PUBLIC_URL + "/assets/images/icon_export.png"} alt="" />엑셀 내보내기</button>
                        {/* <button className="btn btn-primary w-80px px-0">발행 신청</button> */}
                    </div>
                </div>

                <div className="table_scroll">
                    <table className="table table-bordered my_table">
                        <thead>
                            <tr>
                                <th style={{ width: "2.84%" }}>
                                    <div className="checkbox_outer">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                        />
                                    </div>
                                </th>
                                <th style={{ width: "9.76%" }}>발주일자​</th>
                                <th style={{ width: "9%" }}>출하일자​</th>
                                <th style={{ width: "9.47%" }}>납품일자​</th>
                                <th style={{ width: "8.05%" }}>요청자​</th>
                                <th style={{ width: "10.42%" }}>담당자​</th>
                                <th style={{ width: "15.1%" }}>품목​</th>
                                <th style={{ width: "5.68%" }}>규격​</th>
                                <th style={{ width: "7.1%" }}>수량​</th>
                                <th style={{ width: "7.58%" }}>환종​</th>
                                <th>금액​</th>
                                <th>상태<img src={process.env.PUBLIC_URL + "/assets/images/icon-table-sort-down.png"} alt="" />​</th>
                            </tr>
                        </thead>
                        <tbody>
                            {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map(() => (
                                <tr>
                                    <td style={{ width: "2.85%" }}>
                                        <div className="checkbox_outer">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                            />
                                        </div>
                                    </td>
                                    <td className="text-center"></td>
                                    <td className="text-center"></td>
                                    <td className="text-center"></td>
                                    <td className="text-center"></td>
                                    <td className="text-center"></td>
                                    <td className="text-center"></td>
                                    <td className="text-center"></td>
                                    <td className="text-center"></td>
                                    <td className="text-center"></td>
                                    <td className="text-center"></td>
                                    <td className="text-center"></td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                <div className="pagination-container">
                    <ul>
                        <li className="pg_nav">
                            <img
                                src={process.env.PUBLIC_URL + "/assets/images/pg_first.png"}
                                alt="First Page"
                                className=""
                            />
                        </li>
                        <li className="pg_nav">
                            <img
                                src={process.env.PUBLIC_URL + "/assets/images/pg_prev.png"}
                                alt="Previous Page"
                                className=""
                            />
                        </li>
                        <li className="active">1</li>
                        <li className="">2</li>
                        <li className="">3</li>
                        <li className="">4</li>
                        <li className="">5</li>
                        <li className="pg_nav">
                            <img
                                src={process.env.PUBLIC_URL + "/assets/images/pg_next.png"}
                                alt="Next Page"
                                className=""
                            />
                        </li>
                        <li className="pg_nav">
                            <img
                                src={process.env.PUBLIC_URL + "/assets/images/pg_last.png"}
                                alt="Last Page"
                                className=""
                            />
                        </li>
                    </ul>
                </div>
            </div>
        </>
    );
}